// extracted by mini-css-extract-plugin
export default {"button":"_45b2f2b"};